/** @jsx jsx */
import { Flex, Text, jsx } from 'theme-ui'
import { func } from 'prop-types'
import RedirectCounter from './RedirectCounter'
import { useState } from 'react'
import GetRefreshToken from './GetRefreshToken'
import { CfnButton } from '../common/Buttons'

const TimeOutReminder = ({ handleClose }) => {
  const [clickedContinue, setClickedContinue] = useState(false)
  const handleGetData = token => {
    if (token) {
      handleClose()
    }
  }
  const handleContinueSession = () => {
    setClickedContinue(true)
  }

  const redirectUrl = process.env.GATSBY_AUTH_REDIRECT_LINK

  const logOut = () => {
    localStorage.setItem('token', '')
    window.location.href = redirectUrl
  }

  return (
    <div
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          justifyContent: ['center'],
          alignItems: ['center'],
          mx: [3, 32],
          mb: 32,
          mt: 5,
        }}
      >
        <Text variant="h4" sx={{ mb: 4, fontWeight: 'normal' }}>
          Session Timeout
        </Text>
        <Text variant="h6">
          Due to inacitivity, your session will expire in
        </Text>
        <RedirectCounter
          sx={{
            mt: 6,
            mb: 40,
            fontSize: [7, 9],
            justifyContent: ['center'],
            alignItems: ['center'],
          }}
          countDownFrom={5}
          countDownUnit="minute"
          redirectUrl={redirectUrl}
        />
        <Flex
          sx={{
            flexDirection: ['column', 'row'],
            justifyContent: ['center'],
            alignItems: ['center'],
          }}
        >
          <CfnButton
            onClick={logOut}
            sx={{ mr: [0, 5], mb: [5, 0] }}
            color="forest"
            buttonStyle="secondary"
            size="small"
          >
            Log Out
          </CfnButton>
          <CfnButton
            onClick={handleContinueSession}
            buttonStyle="primary"
            color="forest"
            size="small"
            sx={{ border: '2px', borderColor: 'forest', borderStyle: 'solid' }}
          >
            Continue
          </CfnButton>
        </Flex>
      </Flex>
      {clickedContinue && <GetRefreshToken handleGetData={handleGetData} />}
    </div>
  )
}

TimeOutReminder.propTypes = {
  handleClose: func,
}

export default TimeOutReminder
